import { ISODateTime } from '../types/dates';
import { SessionIndexView } from '../../mainv3/types/sessions';
import moment, { Moment } from 'moment-timezone';

const noneMatch = (matchers) => (l) => {
    return !matchers.some((m) => m(l));
};
const anyMatch = (matchers) => (l) => matchers.some((m) => m(l));
const allMatch = (matchers) => (l) => matchers.every((m) => m(l));

export const Predicates = {
    anyMatch,
    allMatch,
    noneMatch,
};

export const SessionPredicates = {
    /**
     * baseTimeから、startWeek週目以降、endWeek週目未満に開始されるセッションのみを返すフィルタ
     * 週数は0開始であることに注意
     * 例：
     * startsInWeeks('2021-03-02', 0, 1)
     *  - OK: 2021-03-02
     *  - OK: 2021-03-08
     *  - NG: 2021-03-09
     * startsInWeeks('2021-03-02', 1, 2)
     *  - NG: 2021-03-08
     *  - OK: 2021-03-09
     *  - OK: 2021-03-10
     *  - NG: 2021-03-15
     *
     * @param baseTime
     * @param startWeek 開始週（0開始）
     * @param endWeek 終了週（0開始、exclusive）
     */
    startsInWeeks(baseTime: ISODateTime | Moment, startWeek, endWeek) {
        return (session: SessionIndexView) => {
            return (
                moment(session.starts_at).isSameOrAfter(moment(baseTime).add(startWeek, 'week')) &&
                moment(session.starts_at).isBefore(moment(baseTime).add(endWeek, 'week'))
            );
        };
    },
    startsBefore(baseTime) {
        return (session: SessionIndexView) => {
            return moment(session.starts_at).isBefore(moment(baseTime));
        };
    },
};
